import { combineReducers } from 'redux';

import loading from 'modules/global/reducers/generic.loading';
import * as types from 'modules/interventions/actionTypes';

import mobility from './mobility';
import open from './open';

/**
 * @typedef {{
 *  open: boolean,
 *  mobility: { interventionId: string } & import('modules/selfServices/types').Mobility,
 *  loading: {
 *    fetching: boolean,
 *    updating: boolean,
 *  }
 * }} MobilityModalReducer
 */
export default combineReducers({
  open,
  mobility,
  loading: combineReducers({
    fetching: loading(types.FETCH_MOBILITY_ITEM),
    updating: loading(types.UPDATE_MOBILITY_ITEM),
  }),
});
